var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNissan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.899 12.61c-.296-.084-.625-.124-1.319-.212-2.87-.12-9.965-.402-13.58-.402s-10.71.282-13.58.402c-.694.088-1.023.128-1.319.212C.2 12.828 0 13.159 0 13.819v4.527c0 .66.693 1.106 1.17 1.196.478.09.78.126 1.283.175 2.567.163 8.524.501 13.547.507 5.023-.005 10.98-.344 13.547-.507.503-.049.805-.085 1.283-.175.477-.09 1.17-.535 1.17-1.196v-4.527c0-.66-.198-.992-1.101-1.209z",
    fill: "url(#paint0_linear_109_818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.488 12.788c1.413-5.021 6.054-8.705 11.563-8.705 5.493 0 10.125 3.664 11.551 8.665l.013.043c.819-.094 1.552-.239 2.07-.38l-.02-.07C28.046 6.382 22.564 2 16.052 2 9.517 2 4.021 6.412 2.42 12.398c.72.202 1.248.286 2.068.39z",
    fill: "url(#paint1_radial_109_818)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.569 19.369l-.038.118c-1.502 4.88-6.073 8.43-11.48 8.43-5.45 0-10.05-3.604-11.515-8.544-.896.162-1.198.224-2.083.344C4.093 25.645 9.559 30 16.05 30c6.495 0 11.963-4.36 13.6-10.292a26.07 26.07 0 01-2.082-.34z",
    fill: "url(#paint2_radial_109_818)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.776 12.777c.34-.143.67-.372 1.182-.52a10.773 10.773 0 0110.093-6.949c4.608 0 8.54 2.873 10.078 6.912.005.014.01.03.015.04.265.094 1.045.417 1.287.525l.184.006a1.095 1.095 0 01-.013-.044c-1.427-4.999-6.058-8.662-11.551-8.662-5.508 0-10.15 3.683-11.562 8.703.081 0 .237-.007.287-.011z",
    fill: "url(#paint3_radial_109_818)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.963 4.425c5.154 0 9.723 3.14 11.453 8.317l.014.044.184.005c-.004-.018-.01-.03-.012-.043-1.427-5-6.059-8.662-11.552-8.662-5.508 0-10.149 3.682-11.562 8.702.11-.002.163-.002.288-.01 1.547-4.915 6.07-8.353 11.187-8.353z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.276 19.383c-.37.211-.83.415-1.2.533a10.775 10.775 0 01-10.026 6.778c-4.554 0-8.449-2.806-10.024-6.772-.424-.12-1.058-.415-1.298-.539l-.193-.01c1.466 4.939 6.066 8.544 11.516 8.544 5.425 0 10.008-3.572 11.495-8.476l.023-.072c-.086.003-.217.014-.293.014z",
    fill: "url(#paint4_radial_109_818)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.643 12.938c-.76-.095-1.28-.085-3.131-.15l-.257-.009c-3.358-.117-8.403-.275-11.255-.275-2.852 0-7.896.158-11.255.275l-.256.01c-1.853.065-2.37.054-3.131.149-.76.095-1.358.435-1.358 1.014v4.198c0 .579.72 1.048 1.357 1.048 0 0 8.12.512 14.643.518 6.523-.006 14.643-.518 14.643-.518.637 0 1.357-.47 1.357-1.048v-4.198c0-.579-.597-.919-1.357-1.014z",
    fill: "url(#paint5_radial_109_818)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.276 19.383c-1.593 4.83-6.074 8.195-11.136 8.195-5.114 0-9.651-3.091-11.412-8.195l-.192-.01c1.465 4.939 6.067 8.544 11.517 8.544 5.451 0 10.053-3.607 11.517-8.549l-.294.015z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.286 19.382h-.01c-.37.212-.831.415-1.2.534a10.684 10.684 0 01-2.178 3.409 11.697 11.697 0 003.388-3.943z",
    fill: "#8C8C8C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51 23.638a10.7 10.7 0 01-2.484-3.716c-.424-.12-1.057-.416-1.297-.54.256.544.558 1.063.903 1.553.706.939 1.56 1.776 2.534 2.484.113.075.228.148.345.219z",
    fill: "#4D4D4D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.536 19.373h-.004c-.893.162-1.196.224-2.08.344.072.258.15.513.237.765l1.847-1.109z",
    fill: "#252525"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.502 14.797c-.267-.61-.172-.546-.753-.562-.047-.016-.173-.016-.346-.016-.172 0-.204 0-.345.016-.55 0-.455-.032-.643.37 0 0-.943 2.164-1.35 3.062l-.016.032c-.079.16-.032.16.094.16h.848c.063 0 .094-.031.11-.064 0 0 .125-.272.282-.657h2.072c.157.369.267.641.267.657.015.048.063.064.11.064h.878c.126 0 .158.017.11-.096-.157-.385-1.177-2.63-1.318-2.966zm-1.805 1.571c.266-.641.534-1.267.534-1.283.015-.032.047-.048.094-.048.015-.016.063-.016.11-.016.031 0 .078 0 .094.016.031 0 .063.016.078.064.064.176.298.722.518 1.267h-1.428zM9.395 14.187c.079 0 .095.032.095.096v3.433c0 .08-.016.112-.11.112h-.816c-.094 0-.11-.016-.11-.112v-3.433c0-.064.016-.096.078-.096h.863zm-1.742.032c.094 0 .11.032.11.112v3.417c0 .096-.016.112-.11.112h-.957c-.565 0-.612 0-.8-.32-.393-.626-1.57-2.47-1.57-2.47v2.678c0 .097-.016.112-.11.112h-.707c-.094 0-.11-.015-.11-.112v-3.417c0-.08.016-.112.11-.112h.816c.613 0 .691-.016.911.305.173.289 1.601 2.534 1.601 2.534V14.33c0-.08.016-.112.11-.112h.706zm20.954 0c.095 0 .11.032.11.112v3.417c0 .096-.015.112-.11.112h-.956c-.566 0-.613 0-.801-.32-.393-.626-1.57-2.47-1.57-2.47v2.678c0 .096-.016.112-.11.112h-.706c-.094 0-.11-.016-.11-.112V14.33c0-.08.016-.112.11-.112h.816c.612 0 .69-.016.91.305.189.289 1.601 2.534 1.601 2.534V14.33c0-.08.016-.112.11-.112h.706zM12.99 15.615c.628.064 1.083.176 1.209.786 0 .047.016.208.016.384 0 .113 0 .257-.032.385-.11.577-.534.69-1.192.69h-2.638c-.094 0-.11-.016-.11-.113v-.577c0-.096.016-.112.11-.112h2.668c.11 0 .141-.032.157-.113v-.24c-.016-.065-.031-.16-.173-.176a49.905 49.905 0 01-1.773-.16c-.77-.081-.958-.418-.99-.707-.015-.096-.015-.224-.015-.336 0-.097 0-.24.016-.353.11-.514.487-.754 1.146-.754h2.558c.095 0 .126.016.126.096v.594c0 .08-.032.112-.126.096h-2.511c-.11 0-.157.048-.173.16v.144c0 .08.047.145.157.16.299.033 1.225.113 1.57.146zm4.536 0c.628.064 1.083.176 1.209.786 0 .047.016.208.016.384 0 .113 0 .257-.032.385-.11.577-.533.69-1.193.69H14.89c-.094 0-.11-.016-.11-.113v-.577c0-.096.016-.112.11-.112h2.669c.11 0 .14-.032.157-.113v-.24c-.017-.065-.048-.16-.173-.176a49.855 49.855 0 01-1.774-.16c-.77-.081-.942-.418-.989-.707-.016-.096-.016-.224-.016-.336 0-.097 0-.24.016-.353.11-.514.487-.754 1.146-.754h2.559c.093 0 .125.016.125.096v.594c0 .08-.032.112-.125.096h-2.512c-.11 0-.157.048-.173.16v.144c0 .08.032.145.158.16.298.033 1.224.113 1.569.146z",
    fill: "url(#paint6_radial_109_818)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(22.3141 0 0 22.8011 7.017 -3.629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(46.472 0 0 47.4863 61.019 32.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.267 0 0 14.5784 12.377 22.414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(27.071 0 0 27.6619 23.89 37.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(21.5123 0 0 21.9818 15.786 4.885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_109_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.4898 0 0 14.806 16.284 7.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_818",
    x1: 16,
    y1: 2.413,
    x2: 16,
    y2: 25.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNissan);
export default __webpack_public_path__ + "static/media/nissan.b9d6b9dee5ff2ea0d074348665a3166e.svg";
export { ForwardRef as ReactComponent };